import React, { useMemo, useState } from "react";
import { Offcanvas } from "react-bootstrap";
import { Link, useLocation } from "react-router-dom";
import { shortLogo } from "../config/config";

export default function MobileMenuOffcanvas({
     show,
     handleClose,
     setShow,
     title,
     auth,
     navItems,
}) {
     const location = useLocation();
     const [openKey, setOpenKey] = useState(null);

     const visibleNavItems = useMemo(() => navItems || [], [navItems]);

     const isActive = (path) => {
          if (!path) return false;
          if (path === "/") return location.pathname === "/";
          return location.pathname.startsWith(path);
     };

     const toggleAccordion = (key) => {
          setOpenKey((prev) => (prev === key ? null : key));
     };

     return (
          <Offcanvas
               show={show}
               onHide={handleClose}
               placement="start"
               className="hp-offcanvas"
               backdropClassName="hp-offcanvas-backdrop"
               scroll={false}
          >
               <div className="hp-offcanvas__wrap">
                    {/* Header */}
                    <div className="hp-offcanvas__header">
                         <div className="hp-offcanvas__brand">
                              <div className="hp-offcanvas__logo">
                                   <img src={shortLogo} alt={title} />
                              </div>
                              <div className="hp-offcanvas__title">{title}</div>
                         </div>

                         <button
                              type="button"
                              className="hp-offcanvas__close"
                              aria-label="Close menu"
                              onClick={handleClose}
                         >
                              <span />
                              <span />
                         </button>
                    </div>

                    {/* Body */}
                    <div className="hp-offcanvas__body">
                         <div className="hp-offcanvas__search">
                              <div className="hp-offcanvas__searchIcon" aria-hidden="true" />
                              <input
                                   className="hp-offcanvas__searchInput"
                                   placeholder="Search menu..."
                                   onChange={(e) => {
                                        // optional: filter logic later
                                   }}
                              />
                         </div>

                         <ul className="hp-nav">
                              {visibleNavItems.map((item, index) => {
                                   const hasChildren =
                                        Array.isArray(item.children) && item.children.length > 0;

                                   // item key for accordion
                                   const key = `${item.name}-${index}`;
                                   const expanded = openKey === key;

                                   if (!hasChildren) {
                                        return (
                                             <li className="hp-nav__item" key={key}>
                                                  <Link
                                                       to={item.path}
                                                       className={`hp-nav__link ${isActive(item.path) ? "is-active" : ""}`}
                                                       onClick={() => setShow(false)}
                                                  >
                                                       <span className="hp-nav__dot" aria-hidden="true" />
                                                       <span className="hp-nav__text">{item.name}</span>
                                                       <span className="hp-nav__chev" aria-hidden="true" />
                                                  </Link>
                                             </li>
                                        );
                                   }

                                   return (
                                        <li className={`hp-nav__item ${key}`} key={key}>
                                             <button
                                                  type="button"
                                                  className={`hp-nav__accordionBtn ${expanded ? "is-open" : ""}`}
                                                  onClick={() => toggleAccordion(key)}
                                                  aria-expanded={expanded}
                                             >
                                                  <span className="hp-nav__dot" aria-hidden="true" />
                                                  <span className="hp-nav__text">{item.name}</span>
                                                  <span className="hp-nav__arrow" aria-hidden="true" />
                                             </button>

                                             <div className={`hp-nav__panel ${expanded ? "is-open" : ""}`}>
                                                  <ul className="hp-nav__sub">
                                                       {item.children.map((child, i) => (
                                                            <li className="hp-nav__subItem" key={`${key}-child-${i}`}>
                                                                 <Link
                                                                      to={child.path}
                                                                      className={`hp-nav__subLink ${isActive(child.path) ? "is-active" : ""
                                                                           }`}
                                                                      onClick={() => setShow(false)}
                                                                 >
                                                                      <span className="hp-nav__subBullet" aria-hidden="true" />
                                                                      <span className="hp-nav__subText">{child.name}</span>
                                                                 </Link>
                                                            </li>
                                                       ))}
                                                  </ul>
                                             </div>
                                        </li>
                                   );
                              })}
                         </ul>

                         {/* Footer CTA */}
                         <div className="hp-offcanvas__footer">
                              <Link
                                   to={auth ? "/submit" : "/login"}
                                   className="hp-offcanvas__cta"
                                   onClick={() => setShow(false)}
                              >
                                   <span className="hp-offcanvas__ctaGlow" aria-hidden="true" />
                                   {auth ? "Submit Prompts" : "Login Now"}
                              </Link>

                              <div className="hp-offcanvas__mini">
                                   <span className="hp-offcanvas__miniDot" />
                                   <span className="hp-offcanvas__miniText">{title} • Thedc</span>
                              </div>
                         </div>
                    </div>
               </div>
          </Offcanvas>
     );
}